import { useContext } from 'react';
import FieldContext from '../../../FieldContext';
import ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';
import ModelsContext from '../../../../../../ModelsContext';
import useApi from '@/lib/api/useApi';
import { type EditorFieldWithoutRelations } from '@/lib/types';
import SelectedModelIdContext from '@/pages/EditorPage/ChallengeModelsEditor/SelectedModelIdContext';

const useMoveCurrentFieldToSectionContentGroup = (
  allHighestPositions: Record<ContentGroupType, number>,
  lowestFieldPositionInSectionBottomContent: number,
): ((contentGroup: ContentGroupType) => Promise<void>) => {
  const api = useApi();

  const [, setModels] = useContext(ModelsContext);
  const selectedModelId = useContext(SelectedModelIdContext);

  const { field } = useContext(FieldContext);

  const newLowestPositionForBottomContent =
    lowestFieldPositionInSectionBottomContent / 2 || 1;

  const moveCurrentFieldToSectionContentGroup = async (
    newSectionContentGroup: ContentGroupType,
  ): Promise<void> => {
    const highestPositionInNewSectionContentGroup =
      allHighestPositions[newSectionContentGroup];

    const newPosition =
      newSectionContentGroup === ContentGroupType.BOTTOM
        ? newLowestPositionForBottomContent
        : highestPositionInNewSectionContentGroup + 1;

    const updatedField = await api.post<EditorFieldWithoutRelations>(
      `editor/challenge-model/fields/${field!.id}/position/set-content-group`,
      {
        contentGroup: newSectionContentGroup,
        position: newPosition,
      },
    );

    setModels(models => {
      models[selectedModelId].fields[field!.id] = {
        ...models[selectedModelId].fields[field!.id],
        ...updatedField,
      };
    });
  };

  return moveCurrentFieldToSectionContentGroup;
};

export default useMoveCurrentFieldToSectionContentGroup;
